(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["je-vana-scroll-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__jeVanaScrollVideo) return;
  window.__jeVanaScrollVideo = true;

  var instances = new Map();
  var MAX_CONCURRENT = 6;

  function mq(q) {
    return window.matchMedia ? window.matchMedia(q) : { matches: false };
  }
  function onMq(m, fn) {
    if (!m.addEventListener) { if (m.addListener) m.addListener(fn); return; }
    m.addEventListener('change', fn);
  }
  function offMq(m, fn) {
    if (!m.removeEventListener) { if (m.removeListener) m.removeListener(fn); return; }
    m.removeEventListener('change', fn);
  }
  var reduceMq = mq('(prefers-reduced-motion: reduce)');
  var mobileMq = mq('(max-width: 749px)');

  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }
  function smooth(a, b, x) {
    var t = clamp((x - a) / (b - a), 0, 1);
    return t * t * (3 - 2 * t);
  }
  function pad(n) { return ('0000' + n).slice(-4); }

  function buildUrlFn(root) {
    var pattern = (root.getAttribute('data-frame-pattern') || '').trim();
    var probe = root.getAttribute('data-probe-url') || '';
    if (pattern.indexOf('{index}') > -1) {
      return function (n) { return pattern.replace(/\{index\}/g, pad(n)); };
    }
    if (probe) {
      var m = probe.match(/^(.*)0001(\.[a-z0-9]+)(\?.*)?$/i);
      if (m) return function (n) { return m[1] + pad(n) + m[2] + (m[3] || ''); };
    }
    return null;
  }

  function Instance(root) {
    this.root = root;
    this.stage = root.querySelector('[data-jv-stage]');
    this.canvas = root.querySelector('[data-jv-canvas]');
    this.poster = root.querySelector('.jv__poster');
    this.intro = root.querySelector('[data-jv-intro]');
    this.final = root.querySelector('[data-jv-final]');
    this.pops = [].slice.call(root.querySelectorAll('[data-jv-pop]')).map(function (el) {
      return {
        el: el,
        start: (parseFloat(el.getAttribute('data-start')) || 0) / 100,
        end: (parseFloat(el.getAttribute('data-end')) || 0) / 100
      };
    });
    this.ctx = this.canvas ? this.canvas.getContext('2d') : null;
    this.count = parseInt(root.getAttribute('data-frame-count'), 10) || 0;
    this.maxDpr = parseFloat(root.getAttribute('data-max-dpr')) || 2;
    this.urlFn = buildUrlFn(root);
    this.images = new Array(this.count);
    this.loaded = new Uint8Array(this.count);
    this.loading = new Uint8Array(this.count);
    this.loadedCount = 0;
    this.active = 0;
    this.queue = [];
    this.qi = 0;
    this.drawn = -1;
    this.target = 0;
    this.dirty = true;
    this.raf = 0;
    this.destroyed = false;
    this.fellBack = false;
    this.loadStarted = false;

    this.tick = this.tick.bind(this);
    this.request = this.request.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onMotion = this.onMotion.bind(this);
    this.onBreakpoint = this.onBreakpoint.bind(this);

    this.init();
  }

  Instance.prototype.init = function () {
    if (!this.ctx || this.count < 2 || !this.urlFn || reduceMq.matches) {
      this.fallback();
      return;
    }
    var self = this;
    this.root.classList.add('jv--active');

    window.addEventListener('scroll', this.request, { passive: true });
    window.addEventListener('resize', this.onResize);
    window.addEventListener('orientationchange', this.onResize);
    onMq(reduceMq, this.onMotion);
    onMq(mobileMq, this.onBreakpoint);

    if (window.ResizeObserver) {
      this.ro = new ResizeObserver(this.onResize);
      this.ro.observe(this.stage);
    }

    this.resize();
    this.request();

    // First frame immediately; the rest only when the section is near the viewport.
    this.load(0, function (ok) {
      if (self.destroyed) return;
      if (!ok) { self.fallback(); return; }
      self.root.classList.add('jv--loaded');
      self.dirty = true;
      self.request();
    });

    if (window.IntersectionObserver) {
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          self.startLoading();
          self.io.disconnect();
          self.io = null;
        }
      }, { rootMargin: '150% 0px' });
      this.io.observe(this.root);
    } else {
      this.startLoading();
    }
  };

  Instance.prototype.buildOrder = function () {
    var seen = {};
    var order = [];
    var last = this.count - 1;
    var strides = [12, 6, 3, 1];
    function add(i) { if (!seen[i]) { seen[i] = 1; order.push(i); } }
    add(0);
    add(last);
    for (var s = 0; s < strides.length; s++) {
      for (var i = 0; i <= last; i += strides[s]) add(i);
    }
    return order;
  };

  Instance.prototype.startLoading = function () {
    if (this.loadStarted || this.destroyed || this.fellBack) return;
    this.loadStarted = true;
    this.queue = this.buildOrder();
    this.pump();
  };

  Instance.prototype.pump = function () {
    var self = this;
    while (!this.destroyed && this.active < MAX_CONCURRENT && this.qi < this.queue.length) {
      var i = this.queue[this.qi++];
      if (this.loaded[i] || this.loading[i]) continue;
      this.active++;
      this.load(i, function () {
        self.active--;
        self.pump();
      });
    }
    if (!this.destroyed && this.active === 0 && this.qi >= this.queue.length) {
      if (this.loadedCount < this.count * 0.75) this.fallback();
    }
  };

  Instance.prototype.load = function (i, done) {
    var self = this;
    if (this.loaded[i]) { if (done) done(true); return; }
    this.loading[i] = 1;
    var img = new Image();
    img.decoding = 'async';
    function ok() {
      if (self.destroyed) return;
      self.images[i] = img;
      self.loaded[i] = 1;
      self.loading[i] = 0;
      self.loadedCount++;
      // New frame near the current target? Redraw.
      if (self.drawn !== self.target && self.nearest(self.target) === i) self.dirty = true;
      self.request();
      if (done) done(true);
    }
    function fail() {
      if (self.destroyed) return;
      self.loading[i] = 0;
      if (done) done(false);
    }
    img.onload = function () {
      if (img.decode) { img.decode().then(ok, ok); } else { ok(); }
    };
    img.onerror = fail;
    img.src = this.urlFn(i + 1);
  };

  Instance.prototype.nearest = function (idx) {
    if (this.loaded[idx]) return idx;
    for (var d = 1; d < this.count; d++) {
      var a = idx - d, b = idx + d;
      if (a >= 0 && this.loaded[a]) return a;
      if (b < this.count && this.loaded[b]) return b;
      if (a < 0 && b >= this.count) break;
    }
    return -1;
  };

  Instance.prototype.params = function () {
    var r = this.root, m = mobileMq.matches ? 'mobile' : 'desktop';
    return {
      fit: r.getAttribute('data-fit-' + m) === 'cover' ? 'cover' : 'contain',
      x: (parseFloat(r.getAttribute('data-x-' + m)) || 0) / 100,
      y: (parseFloat(r.getAttribute('data-y-' + m)) || 0) / 100
    };
  };

  Instance.prototype.resize = function () {
    var w = this.stage.clientWidth, h = this.stage.clientHeight;
    if (!w || !h) return;
    var dpr = Math.min(window.devicePixelRatio || 1, this.maxDpr);
    var cw = Math.round(w * dpr), ch = Math.round(h * dpr);
    var cap = 3200; // hard cap on the longest canvas side
    var big = Math.max(cw, ch);
    if (big > cap) { cw = Math.round(cw * cap / big); ch = Math.round(ch * cap / big); }
    if (this.canvas.width !== cw || this.canvas.height !== ch) {
      this.canvas.width = cw;
      this.canvas.height = ch;
    }
    this.dirty = true;
  };

  Instance.prototype.onResize = function () {
    if (this.destroyed || this.fellBack) return;
    this.resize();
    this.request();
  };
  Instance.prototype.onBreakpoint = Instance.prototype.onResize;
  Instance.prototype.onMotion = function () {
    if (reduceMq.matches) this.fallback();
  };

  Instance.prototype.request = function () {
    if (!this.raf && !this.destroyed) this.raf = requestAnimationFrame(this.tick);
  };

  Instance.prototype.progress = function () {
    var rect = this.root.getBoundingClientRect();
    var total = rect.height - this.stage.clientHeight;
    return total > 0 ? clamp(-rect.top / total, 0, 1) : 0;
  };

  Instance.prototype.tick = function () {
    this.raf = 0;
    if (this.destroyed || this.fellBack) return;
    var p = this.progress();
    this.target = Math.round(p * (this.count - 1));
    this.overlays(p);
    var idx = this.nearest(this.target);
    if (idx !== -1 && (idx !== this.drawn || this.dirty)) this.draw(idx);
  };

  Instance.prototype.overlays = function (p) {
    if (this.intro) {
      var a = 1 - smooth(0.08, 0.26, p);
      this.intro.style.opacity = a.toFixed(3);
      this.intro.style.transform = 'translateY(' + ((1 - a) * -10).toFixed(1) + 'px)';
      this.intro.style.visibility = a < 0.01 ? 'hidden' : 'visible';
    }
    var fade = 0.025;
    for (var k = 0; k < this.pops.length; k++) {
      var pop = this.pops[k];
      var o = smooth(pop.start, pop.start + fade, p) * (1 - smooth(pop.end - fade, pop.end, p));
      pop.el.style.opacity = o.toFixed(3);
      pop.el.style.setProperty('--jv-ty', ((1 - o) * 10).toFixed(1) + 'px');
      pop.el.style.setProperty('--jv-draw', (1 - clamp((p - pop.start) / 0.05, 0, 1)).toFixed(3));
      pop.el.style.visibility = o < 0.01 ? 'hidden' : 'visible';
      pop.el.setAttribute('aria-hidden', o < 0.5 ? 'true' : 'false');
    }
    if (this.final) {
      var b = smooth(0.84, 0.96, p);
      this.final.style.opacity = b.toFixed(3);
      this.final.style.transform = 'translate(-50%,' + ((1 - b) * 12).toFixed(1) + 'px)';
      this.final.style.visibility = b < 0.01 ? 'hidden' : 'visible';
    }
  };

  Instance.prototype.resetOverlays = function () {
    [this.intro, this.final].forEach(function (el) {
      if (el) { el.style.opacity = ''; el.style.transform = ''; el.style.visibility = ''; }
    });
    this.pops.forEach(function (pop) {
      pop.el.style.opacity = '';
      pop.el.style.visibility = '';
      pop.el.style.removeProperty('--jv-ty');
      pop.el.style.removeProperty('--jv-draw');
      pop.el.setAttribute('aria-hidden', 'true');
    });
  };

  Instance.prototype.draw = function (idx) {
    var img = this.images[idx];
    if (!img) return;
    var iw = img.naturalWidth, ih = img.naturalHeight;
    var cw = this.canvas.width, ch = this.canvas.height;
    if (!iw || !ih || !cw || !ch) return;
    var pr = this.params();
    var s = pr.fit === 'cover' ? Math.max(cw / iw, ch / ih) : Math.min(cw / iw, ch / ih);
    var dw = iw * s, dh = ih * s;
    var dx = (cw - dw) * pr.x, dy = (ch - dh) * pr.y;
    this.ctx.clearRect(0, 0, cw, ch);
    this.ctx.imageSmoothingEnabled = true;
    this.ctx.imageSmoothingQuality = 'high';
    this.ctx.drawImage(img, dx, dy, dw, dh);
    this.drawn = idx;
    this.dirty = false;
  };

  Instance.prototype.teardown = function () {
    window.removeEventListener('scroll', this.request);
    window.removeEventListener('resize', this.onResize);
    window.removeEventListener('orientationchange', this.onResize);
    offMq(reduceMq, this.onMotion);
    offMq(mobileMq, this.onBreakpoint);
    if (this.ro) { this.ro.disconnect(); this.ro = null; }
    if (this.io) { this.io.disconnect(); this.io = null; }
    if (this.raf) { cancelAnimationFrame(this.raf); this.raf = 0; }
  };

  // Static poster mode: reduced motion, no frames, or too many failed loads.
  Instance.prototype.fallback = function () {
    if (this.fellBack) return;
    this.fellBack = true;
    this.teardown();
    this.root.classList.remove('jv--active', 'jv--loaded');
    if (this.poster && !this.poster.getAttribute('src') && !this.poster.currentSrc && this.urlFn) {
      this.poster.removeAttribute('hidden');
      this.poster.removeAttribute('width');
      this.poster.removeAttribute('height');
      this.poster.src = this.urlFn(1);
    }
    this.resetOverlays();
    this.images = [];
  };

  Instance.prototype.destroy = function () {
    this.destroyed = true;
    this.teardown();
    this.root.classList.remove('jv--active', 'jv--loaded');
    this.resetOverlays();
    this.images = [];
  };

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new Instance(root));
  }
  function initWithin(scope) {
    var list = scope.querySelectorAll ? scope.querySelectorAll('[data-jv-root]') : [];
    for (var i = 0; i < list.length; i++) initRoot(list[i]);
    if (scope.matches && scope.matches('[data-jv-root]')) initRoot(scope);
  }
  function destroyWithin(scope) {
    instances.forEach(function (inst, root) {
      if (scope === root || scope.contains(root)) {
        inst.destroy();
        instances.delete(root);
      }
    });
  }

  // Shopify theme editor lifecycle
  document.addEventListener('shopify:section:load', function (e) { initWithin(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroyWithin(e.target); });
  // Section settings re-render fires unload then load, so no extra handler is needed.

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initWithin(document); });
  } else {
    initWithin(document);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jevana-heritage-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SELECTOR = '[data-jevana-heritage]';

    function init(root) {
      if (!root || root.getAttribute('data-jh-ready') === 'true') return;
      root.setAttribute('data-jh-ready', 'true');

      var style = root.getAttribute('data-jh-anim');
      if (!style || style === 'none') return;

      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) return;

      var items = root.querySelectorAll('.jevana-heritage__item');
      var line = root.querySelector('.jevana-heritage__timeline');
      if (!items.length) return;

      root.classList.add('jevana-heritage--anim');

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -6% 0px' });

      items.forEach(function (el) { io.observe(el); });
      if (line) io.observe(line);

      // Background image: settle from heavy blur once the section is on screen
      var bgIo = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            root.classList.add('jevana-heritage--ready');
            bgIo.disconnect();
          }
        });
      }, { threshold: 0.05 });
      bgIo.observe(root);
    }

    function initAll(scope) {
      (scope || document).querySelectorAll(SELECTOR).forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jevana-scan-fab"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__jvFabInit) return;
    window.__jvFabInit = true;
    function setup(root) {
      var btn = root.querySelector('.jv-fab__btn');
      var pop = root.querySelector('.jv-fab__pop');
      var close = root.querySelector('.jv-fab__close');
      if (!btn || !pop) return;
      function set(open) {
        pop.hidden = !open;
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      btn.addEventListener('click', function () { set(pop.hidden); });
      if (close) close.addEventListener('click', function () { set(false); btn.focus(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !pop.hidden) { set(false); btn.focus(); } });
      document.addEventListener('click', function (e) { if (!pop.hidden && !root.contains(e.target)) set(false); });
    }
    function all() { document.querySelectorAll('.jv-fab').forEach(function (r) { if (!r.__jv) { r.__jv = 1; setup(r); } }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
    document.addEventListener('shopify:section:load', all);   // theme editor re-renders
  })();

  } catch(e) { console.error(e); }
})();
})();
